import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutSummary from "./sections/AboutSummary";
import ServicesHighlights from "./sections/ServicesHighlights";
import PortfolioPreview from "./sections/PortfolioPreview";
import TestimonialsPreview from "./sections/TestimonialsPreview";
import ContactCta from "./sections/ContactCta";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutSummary />
      <ServicesHighlights />
      <PortfolioPreview />
      <TestimonialsPreview />
      <ContactCta />
      <Footer />
    </div>;
}